import { Alert, AlertProps } from '@mantine/core';
import { FC } from 'react';

const BookitupAlert: FC<AlertProps> = ({ children, ...rest }) => (
  <Alert
    sx={(theme) => ({
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.lightBlue[0],
    })}
    {...rest}
  >
    {children}
  </Alert>
);

export default BookitupAlert;
